import React, { useState } from "react";
import { Phone, X, ChevronDown, ChevronUp } from "lucide-react";
import { useNavigate } from "react-router-dom";
import therapistLogo from '../img/Tiny Therapist Logo_Without Background (1).png'

const navLinks = [
    { label: "Home", path: "/" },
    { label: "About", path: "/about" },
    { label: "Therapy Sessions", path: "/therapy-sessions" },
    { label: "Specialty", path: "/specialty" },
    // { label: "Blog", path: "/blog" },
    { label: "Contact", path: "/contact" },
];


const Header = () => {
    const [showServices, setShowServices] = useState(false);
    const [drawerOpen, setDrawerOpen] = useState(false);
    const navigate = useNavigate()

    const navigateTo = (path) => {
        window.location.href = path;
    };

    const toggleDrawer = () => {
        setDrawerOpen(!drawerOpen);
    };

    return (
        <>
            {/* <div className="hob-top-header">
                <div className="hob-top-header__contacts">
                    <span
                        onClick={() => (window.location.href = "tel:8108446414")}
                        style={{ cursor: "pointer" }}
                    >
                        <Phone size={16} style={{ marginRight: "0.5rem" }} />
                        +91 81084 46414
                    </span>

                    <span
                        onClick={() => (window.location.href = "tel:18002032499")}
                        style={{ cursor: "pointer" }}
                    >
                        <Phone size={16} style={{ marginRight: "0.5rem" }} />
                        18002032499
                    </span>
                </div>
            </div> */}

            <header className="hob-header">
                <div className="hob-header__logo" onClick={() => navigateTo("/")}>
                    {/* The Tiny Therapist */}
                    <img src={therapistLogo} alt="" />
                </div>

                <nav className={`hob-header__nav ${drawerOpen ? "active" : ""}`}>
                    {navLinks.map((link) => (
                        <span key={link.path} onClick={() => navigateTo(link.path)}>
                            {link.label}
                        </span>
                    ))}
                </nav>

                <button
                    onClick={() => navigate('/book-session')}
                    className="hob-header__call-button"
                    style={{ cursor: "pointer" }}
                >

                    Book Session
                </button>

                {/* hob-Hamburger icon for mobile */}
                <div className="hob-hamburger-icon" onClick={toggleDrawer}>
                    <span></span>
                    <span></span>
                    <span></span>
                </div>
            </header>

            {/* Drawer navigation */}
            <div className={`hob-drawer ${drawerOpen ? "hob-open" : ""}`}>
                <div className="hob-drawer-content">
                    <button className="hob-drawer-close-btn" onClick={toggleDrawer}>
                        <X size={20} />
                    </button>
                    <nav className="hob-header__nav">
                        {navLinks.map((link) => (
                            <span key={link.path} onClick={() => navigateTo(link.path)}>
                                {link.label}
                            </span>
                        ))}
                    </nav>

                    <button
                        className="hob-header__call-button-mobile"
                        onClick={() => navigate('/book-session')}
                    >
                        Book Session
                    </button>
                </div>
            </div>
        </>
    );
};

export default Header;
